<template>
  <div>
    <!-- <v-layout> -->
    <ag-grid-vue
      style="
        width: 100%;
        height: 530px;
        font-size: 16px;
        border-bottom: 2px solid #297286;
        border-right: 2px solid #297286;
      "
      class="ag-theme-balham center-box taskValidationGrid"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :gridOptions="gridOptions"
      id="myGrid"
      data-cy="daily-tasks"
      @grid-ready="onGridReady"
      :overlayNoRowsTemplate="overlayNoRowsTemplate"
    >
    </ag-grid-vue>
    <div v-if="taskHistoryPopUp" class="popover-content">
      <p>
        <strong>Task History </strong>
        <v-icon
          color="rgba(21, 102, 124, 0.9)"
          @click="taskHistoryPopUp = false"
          style="float: right"
          >mdi-close</v-icon
        >
      </p>
      <div class="comments-container notes-container">
        <div v-for="item in taskUpdateData" :key="item.commentUUID">
          <p style="color: #07688a; font-weight: bold">
            <span style="background-color: #5bc0de; color: white">{{
              item.dateCreated
            }}</span>
            : <v-icon>mdi-account</v-icon>{{ item.author }}
          </p>
          <p class="list-group-item-text">
            <strong>Status :</strong> {{ item.taskStatus }}
          </p>
          <p class="list-group-item-text">
            <strong>Status Basis:</strong>
            {{ item.taskStatusBasis }}
          </p>
          <p class="list-group-item-text" v-if="item.text">
            {{ item.text }}
          </p>
          <p class="list-group-item-text" v-else>No Data</p>
          <v-divider></v-divider>
        </div>
      </div>
    </div>
    <div v-if="dialog3" class="popover-content">
      <h4>
        Task Status
        <v-icon
          color="rgba(21, 102, 124, 0.9)"
          @click="clear"
          style="float: right"
          >mdi-close</v-icon
        >
      </h4>
      <v-divider></v-divider>
      <h5>
        {{ this.currentInfo.taskStatus }} ({{ this.currentInfo.staffId }})
      </h5>
      <p data-cy="task-status-duid">{{ this.currentInfo.duid }}</p>
      <div class="searchTitle">STATUS</div>
      <v-select
        :items="statusItems"
        v-model="statusChange"
        variant="outlined"
        bg-color="white"
				density="compact"
        data-cy="task-status-status"
      ></v-select>
			<div class="searchTitle">COMMENTS</div>
      <v-textarea
        outlined
        v-model="addedComment"
        rows="2"
        row-height="20"
        density="compact"
        variant="outlined"
        bg-color="white"
        style="margin-bottom: 0px"
        data-cy="task-status-comment"
      ></v-textarea>
      <v-divider></v-divider>
      <v-btn
        @click="getTaskForId"
        :disabled="!statusChange"
        id="submitButton"
        small
        data-cy="task-status-submit-btn"
        >Submit</v-btn
      >
    </div>
    <!-- </v-layout> -->
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles//ag-grid.css";
import "ag-grid-community/styles//ag-theme-alpine.css";
import { authTokenService } from "@/services/authTokenService.js";
import { taskService } from "@/services/task.service.js";
import { trackService } from "@/services/track.services.js";
import { appSettings } from "@/common/app.settings.js";
import { STORE_CONSTANTS } from "@/common/store.constants";
import { TASK_CONSTANTS } from "@/common/task.constants.js";

// import { required, digits, email, max, regex } from "vee-validate/dist/rules";
// import {
//   extend,
//   ValidationObserver,
//   ValidationProvider,
//   setInteractionMode,
// } from "vee-validate";
// import { runInThisContext } from "vm";
// extend("required", {
//   ...required,
//   message: "{_field_} can not be empty",
// });

import { mapGetters } from "vuex";

export default {
  name: "DailyTaskListView",
  props: {
    study: String,
    startdate: String,
    enddate: String,
    view: String,
    status: Array,
    spidNumber: String,
    selectedid: String,
  },
  data: function () {
    return {
      STORE_CONSTANTS,
      columnDefs: null,
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      taskUpdateData: null,
      taskHistoryPopUp: false,
      dialog3: false,
      statusItems: ["VALID", "UNDER_REVIEW", "UNKNOWN", "FALSIFIED"],
      statusChange: null,
      addedComment: null,
      theTaskId: null,
      clickedBasis: null,
      fieldsConfig: [],
      overlayNoRowsTemplate: null,
      rowData: [],
      currentInfo: null,
      taskTagMappings: {},
      altLocation: false
    };
  },
  components: {
    AgGridVue,
    // ValidationProvider,
    // ValidationObserver,
  },
  computed: {
    ...mapGetters("allTasks", ["getTotalTaskCount", "getSuspectTaskCount"]),
  },
  /**
   * Component lifecycle beforeMount handler
   */
  beforeMount() {
		this.gridOptions = {};
    this.getColumnsStart();
  },
  /**
   * Component lifecycle mounted handler
   */  
  mounted() {
		this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    window.addEventListener("resize", this.onResize);
  },
  /**
   * Component lifecycle created handler
   */  
  created() {
    this.overlayNoRowsTemplate =
      '<span style="padding: 10px; border: 2px solid #2b7588; background: #e0e0e0; font-size: 14px">There is no data for this query.</span>';

    this.unsubscribe = this.$store.subscribe((mutation, state) => {

      if (mutation.type === this.STORE_CONSTANTS.DAILY_TASKS.MUTATIONS.WITH_NAMESPACE.SET_STAFF_DAILY_TASKS) {
        this.setGridData(state.dailyTasks.staffDaily.tasks);
      }

      if (mutation.type === this.STORE_CONSTANTS.DAILY_TASKS.MUTATIONS.WITH_NAMESPACE.CLEAR_STAFF_DAILY_INFO) {
        this.setGridDataWithRefresh([]);
      }

      // Tasks updated
      if (mutation.type === this.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_TASKS_FEATURES) {
        this.taskTagMappings = {};
        if(state.tracks && state.tracks.taskFeatures) {
          for (let task of state.tracks.taskFeatures) {
            if (task) {
              this.taskTagMappings[task.id] = task.properties.tag;
              this.altLocation = (task.properties?.AlternateLocation === true || task.properties?.alternateLocation === true)
            }
          }
        }        
      }
    });
  },
  /**
   * Component lifecycle updated handler
   */
  updated() {
    this.onResize();
  },
  // beforeDestroy() {
  //   window.removeEventListener("resize", this.onResize);
  //   this.unsubscribe();
  // },
  /**
   * Component lifecycle beforeUnmount handler
   */  
  beforeUnmount() {
    this.gridApi.destroy();

    window.removeEventListener("resize", this.onResize);
    this.unsubscribe();
  },
  methods: {
    /**
     * HAndler for component resize event
     * @param {*} event 
     */
    onResize(event) {
      this.gridApi.sizeColumnsToFit();
    },
    /**
     * Handler for on grid ready event
     * @param {*} params 
     */
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
      const dailyTasks =
        this.$store.getters["dailyTasks/getStaffDailyTaskList"];
      if (dailyTasks && dailyTasks.length > 0) {
        this.setGridDataWithRefresh(dailyTasks);
      }
    },
    /**
     * Handler to clear sort and filters
     */
    clearSortAndFilter() {
      this.gridColumnApi.applyColumnState({
        defaultState: { sort: null },
      });
      this.gridApi.setFilterModel(null);
    },
    /**
     * Sets the column width
     * @param {*} percentage 
     */
    columnWidth(percentage) {
      let colWidth = 16;
      if (document.querySelector("#myGrid").offsetWidth) {
        let parentWidth = document.querySelector("#myGrid").offsetWidth;
        colWidth = parseInt(parentWidth * (percentage / 100));
      }
      return colWidth;
    },
    /**
     * Calls API to get task info
     * @param {*} criteria 
     */
    getTaskAllUpdates(criteria) {
      const me = this;
      taskService
        .getTaskAllUpdates(criteria)
        .then(function (response) {
          if (response && response.data) {
            me.taskUpdateData = response.data.features;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    /**
     * Updates task analysis
     * @param {*} updateCriteria 
     */
    updateTaskAnalysis(updateCriteria) {
      const me = this;
      let info = {
        dataType: "Tasks",
        enddate: me.enddate,
        spid: me.spidNumber,
        staff: me.selectedid,
        startdate: me.startdate,
        status: me.status,
        study: me.study,
      };
      taskService
        .updateTaskAnalysis(
          updateCriteria.study,
          updateCriteria.taskId,
          updateCriteria.status,
          updateCriteria.comment,
          updateCriteria.basis,
          updateCriteria.username
        )
        .then(function (response) {
          if (response && response.data) {
            // refreshing the TaskListView Data (And Map too?)
            me.$emit("selectedRowRefresh");
            // refreshing bottom DataGrid
            me.$store.dispatch(
              me.STORE_CONSTANTS.ALL_TASKS.ACTIONS.WITH_NAMESPACE
                .GET_TASKS_GENERAL,
              info
            );
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    /**
     * Get task for specified ID
     */
    getTaskForId() {
      const me = this;
      let getTaskIdCriteria = {
        study: me.study || "PATH",
        id: me.theTaskId,
      };
      taskService
        .getTaskForId(getTaskIdCriteria)
        .then(function (response) {
          if (response && response.data) {
            me.clickedBasis = response.data.features[0].properties.StatusBasis;
            var profile = authTokenService.getClaims();
            let username = profile.username;
            let updateCriteria = {
              study: me.study || "PATH",
              taskId: me.theTaskId,
              status: me.statusChange,
              comment: me.addedComment,
              basis: me.clickedBasis,
              username: username,
            };
            me.updateTaskAnalysis(updateCriteria);
            me.clear();
          }
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    /**
     * Submit
     */
    submit() {
      const me = this;
      this.$refs.observer.validate();
      this.getTaskForId();
      // apparently needs a delay to recognize the data change for getting a new call
      // window.setTimeout(() => me.$emit("refreshData"), 1000);
    },
    /**
     * Clear
     */
    clear() {
      this.statusChange = null;
      this.addedComment = null;
      // this.$refs.observer.reset();
      this.dialog3 = false;
    },
    /**
     * Get columns start
     */
    getColumnsStart() {
      this.gridOptions = {
        getRowHeight: (params) => (params.data.AlternateLocation ? 70 : 30),
      };
      var study = this.study;
      console.log("DailyTaskListView getColumnsStart this.study", this.study);
      var ListViewGridConfig;
      // var myUiComponents = this.$store.getters["uiTableConfigurations"];
      var myUiComponents = JSON.parse(localStorage.getItem("myUiComponents"));
      for (let piece of myUiComponents) {
        if (piece.idStudyCode === this.study && piece.uiComponents) {
          var mySingleUiComponent = piece.uiComponents;
          for (let componentConfig of mySingleUiComponent) {
            if (componentConfig.componentName === "tasksByStaffDay") {
              ListViewGridConfig = componentConfig;
            }
          }
        }
      }
      console.log("ListViewGridConfig: ", ListViewGridConfig);

      let mapHide = false;
      let duidHide = false;
      let spidHide = false;
      let taskHide = false;
      let statusHide = false;
      let notesHide = false;

      if (ListViewGridConfig && ListViewGridConfig.columnDefs) {
        this.fieldsConfig = ListViewGridConfig.columnDefs;

        for (let piece of this.fieldsConfig) {
          if (piece.field === "point") {
            mapHide = piece.hide;
          }
          if (piece.field === "duid") {
            duidHide = piece.hide;
          }
          if (piece.field === "spid") {
            spidHide = piece.hide;
          }
          if (piece.field === "taskLabel") {
            taskHide = piece.hide;
          }
          if (piece.field === "taskStatus") {
            statusHide = piece.hide;
          }
          if (piece.field === "updates") {
            notesHide = piece.hide;
          }
        }
      }

      this.columnDefs = [
        {
          field: "properties.TaskUUID",
          headerName: "MAP",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            const div = document.createElement("div");
            const img = document.createElement("img");
            const redDropSuspectTask = require("../assets/wgmm_ico_map_suspect.svg");
            const redDropSuspectTaskAlt = require("../assets/wgmm_ico_map_suspect_alt.svg");
            const greenDropValidTask = require("../assets/wgmm_ico_map_valid.svg");            
            const greenDropValidTaskAlt = require("../assets/wgmm_ico_map_valid_alt.svg");
            const turquoiseDropUnderReviewTask = require("../assets/wgmm_ico_map_in_review.svg");
            const purpleDropTask = require("../assets/wgmm_ico_map_no_data.svg");
            const purpleDropTaskAlt = require("../assets/wgmm_ico_map_no_data_alt.svg");
            const tealDropTaskAlt = require("../assets/wgmm_ico_map_other_excluded.svg");
            // Simpliefied
            // var tStatus = params.data.Status
            const tag = this.taskTagMappings[params.data.taskUUID];
            console.log(tag);

            var tStatus = params.data.taskStatus;
            console.log(tStatus);
            console.log(params.data.StatusBasis);
            if (tStatus === "SUSPECT") {
              img.src = (tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT_ALT || this.altLocation === true) ? redDropSuspectTaskAlt : redDropSuspectTask;
            } else if (tStatus === "VALID") {
              img.src = (tag === TASK_CONSTANTS.TASK_TAGS.VALID_ALT) ? greenDropValidTaskAlt : greenDropValidTask;
            } else if (tStatus === "UNDER_REVIEW") {
              img.src = turquoiseDropUnderReviewTask;
            } else if(tStatus === "COMPLETED" && params.data.taskStatusBasis === "E01_EXCLUDED_REMOTE") {
              img.src = tealDropTaskAlt;
            } else {
              img.src = (tag === TASK_CONSTANTS.TASK_TAGS.NO_DATA_ALT) ? purpleDropTaskAlt : purpleDropTask;
            }
            img.style = "width:30px; height: 30px;";
            const me = this;
            div.addEventListener("click", (e) => {
              // zoom to pop up location
              const me = this;
              let trackCriteria = {
                staffId: params.data.staffId,
                study: me.study,
                startdate: me.startdate,
                enddate: me.enddate,
                point: params.data.point,
                taskUUID: params.data.taskUUID,
              };
              taskService
                .getTaskForDisplayPopUp(params.data, me.study)
                .then(function (response) {
                  if (response && response.data) {
                    console.log(
                      "getTaskForDisplayPopUp: response.dat ",
                      response.data
                    );
                    me.$emit("openRecord", {
                      task: response.data,
                      mapInfo: {
                        points: [], //[params.data.geoLocation.lat, params.data.geoLocation.lon],
                        zoom: 16,
                      },
                    });
                  }
                })
                .catch(function (e) {
                  console.log(e);
                });
            });

            div.appendChild(img);
            return div;
          },
          hide: mapHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "duid",
          headerName: "DUID",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            let ptag = document.createElement("p");
            ptag.innerText = params.data.duid || "No Data";
            var img = document.createElement("img");
            img.src = require("../assets/wgmm_ico_copy.svg");
            img.style = "width:20px; height: 20px;";
            img.addEventListener("click", (e) => {
              var copyText = params.data.duid || "No Data";
              navigator.clipboard.writeText(copyText);
            });
            img.addEventListener(
              "mouseenter",
              function (event) {
                img.src = require("../assets/wgmm_ico_copy_active.svg");
              },
              false
            );
            img.addEventListener(
              "mouseleave",
              function (event) {
                img.src = require("../assets/wgmm_ico_copy.svg");
              },
              false
            );
            ptag.appendChild(img);
            div.appendChild(ptag);
            return div;
          },
          hide: duidHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
          sort: "desc",
        },
        {
          field: "spid",
          headerName: "SPID",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            if (params.data.spid) {
              let ptag = document.createElement("p");
              ptag.innerText = params.data.spid || "No Data";
              var img = document.createElement("img");
              img.src = require("../assets/wgmm_ico_copy.svg");
              img.style = "width:20px; height: 20px;";
              img.addEventListener("click", (e) => {
                var copyText = params.data.spid || "No Data";
                navigator.clipboard.writeText(copyText);
              });
              img.addEventListener(
                "mouseenter",
                function () {
                  img.src = require("../assets/wgmm_ico_copy_active.svg");
                },
                false
              );
              img.addEventListener(
                "mouseleave",
                function () {
                  img.src = require("../assets/wgmm_ico_copy.svg");
                },
                false
              );
              ptag.appendChild(img);
              div.appendChild(ptag);
            }
            return div;
          },
          hide: spidHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "taskLabel",
          headerName: "Task Name",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            const element = document.createElement("div");
            const taskName = document.createElement("TR");
            taskName.innerText = params.value;
            element.appendChild(taskName);
            if (params.data.AlternateLocation) {
              const locationIcon = document.createElement("TR");
              const imageElement = document.createElement("img");
              imageElement.src = require("../assets/wgmm_ico_otheraddress.svg");
              imageElement.style.width = "24px";
              imageElement.style.height = "24px";
              imageElement.style.float = "left";

              imageElement.addEventListener("click", (e) => {
                this.$emit("openRecord", {
                  task: params.data,
                  mapInfo: {
                    points: [], //[params.data.geoLocation.lat, params.data.geoLocation.lon], //[params.data.AltInterviewAddress.point.lat, params.data.AltInterviewAddress.point.lon],
                    zoom: 16,
                  },
                });
              });

              locationIcon.appendChild(imageElement);
              element.appendChild(locationIcon);
              const locationLabel = document.createElement("TR");
              const labelThing = document.createElement("label");
              labelThing.innerText =
                params.data.AltInterviewLocation || "No Data";
              labelThing.style.float = "left";
              labelThing.classList.add("label");
              labelThing.classList.add("label-primary");
              labelThing.classList.add("phone");
              locationLabel.appendChild(labelThing);
              element.appendChild(locationLabel);
            }
            return element;
          },
          hide: taskHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "Status",
          headerName: "Status",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            const me = this;
            let div = document.createElement("div");
            var img = document.createElement("img");
            var tStatus = params.data.taskStatus;
            if (tStatus === "SUSPECT") {
              img.src = require("../assets/wgmm_ico_status_suspect.svg");
            } else if (tStatus === "COMPLETED") {
              img.src = (params.data.taskStatusBasis === "E01_EXCLUDED_REMOTE") ? require("../assets/wgmm_ico_map_other_excluded.svg") : 
                require("../assets/wgmm_ico_status_valid.svg");
            } else if (tStatus === "UNDER_REVIEW") {
              img.src = require("../assets/wgmm_ico_status_in_review.svg");
            } else {
              img.src = require("../assets/wgmm_ico_status_valid.svg");
            }
            // everything other than suspect and under_review gets a check mark for some reason, theres only 3 icons total right now
            img.style = "width:20px; height: 20px;";
            div.addEventListener("click", (e) => {
              this.theTaskId = params.data.TaskUUID;
              console.log("params.data: ", params.data);
              console.log("this.theTaskId: ", this.theTaskId);
              this.dialog3 = true;
            });
            div.appendChild(img);
            return div;
          },
          hide: statusHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "properties.TaskUUID",
          headerName: "Notes",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            var img = document.createElement("img");
            img.src = require("../assets/bubble.png");
            img.style = "width:20px; height: 20px;";
            div.addEventListener("click", (e) => {
              this.theTaskId = params.data.TaskUUID;
              this.taskUpdateData = params.data.updates;
              this.taskHistoryPopUp = true;
            });
            div.appendChild(img);
            return div;
          },
          hide: notesHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
      ];
    },
    /**
     * Get columns refresh
     */
    getColumnsRefresh() {
      this.gridApi.setColumnDefs([]);
      var study = this.study;
      var ListViewGridConfig;
      var myUiComponents = JSON.parse(localStorage.getItem("myUiComponents"));

      for (let piece of myUiComponents) {
        if (piece.idStudyCode === this.study && piece.uiComponents) {
          var mySingleUiComponent = piece.uiComponents;
          for (let componentConfig of mySingleUiComponent) {
            if (componentConfig.componentName === "tasksByStaffDay") {
              ListViewGridConfig = componentConfig;
            }
          }
        }
      }
      this.fieldsConfig = ListViewGridConfig.columnDefs;
      let mapHide = false;
      let duidHide = false;
      let spidHide = false;
      let taskHide = false;
      let statusHide = false;
      let notesHide = false;
      for (let piece of this.fieldsConfig) {
        if (piece.field === "point") {
          mapHide = piece.hide;
        }
        if (piece.field === "duid") {
          duidHide = piece.hide;
        }
        if (piece.field === "spid") {
          spidHide = piece.hide;
        }
        if (piece.field === "taskLabel") {
          taskHide = piece.hide;
        }
        if (piece.field === "taskStatus") {
          statusHide = piece.hide;
        }
        if (piece.field === "updates") {
          notesHide = piece.hide;
        }
      }
      this.columnDefs = [
        {
          field: "properties.TaskUUID",
          headerName: "MAP",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            var img = document.createElement("img");
            var redDropSuspectTask = require("../assets/wgmm_ico_map_suspect.svg");
            var redDropSuspectTaskAlt = require("../assets/wgmm_ico_map_suspect_alt.svg");
            var greenDropValidTask = require("../assets/wgmm_ico_map_valid.svg");
            var greenDropValidTaskAlt = require("../assets/wgmm_ico_map_valid_alt.svg");
            var turquoiseDropUnderReviewTask = require("../assets/wgmm_ico_map_in_review.svg");
            const purpleDropTask = require("../assets/wgmm_ico_map_no_data.svg");
            const purpleDropTaskAlt = require("../assets/wgmm_ico_map_no_data_alt.svg");
            const tealDropTaskAlt = require("../assets/wgmm_ico_map_other_excluded.svg");

            const tag = this.taskTagMappings[params.data.taskUUID];

            // Simpliefied
            var tStatus = params.data.taskStatus;
            if (tStatus === "SUSPECT") {
              img.src = (tag === TASK_CONSTANTS.TASK_TAGS.SUSPECT_ALT || this.altLocation === true) ? redDropSuspectTaskAlt : redDropSuspectTask;
            } else if (tStatus === "VALID") {
              img.src = (tag === TASK_CONSTANTS.TASK_TAGS.VALID_ALT) ? greenDropValidTaskAlt : greenDropValidTask;
            } else if (tStatus === "UNDER_REVIEW") {
              img.src = turquoiseDropUnderReviewTask;
            } else if(tStatus === "COMPLETED" && params.data.taskStatusBasis === "E01_EXCLUDED_REMOTE") {
              img.src = tealDropTaskAlt;
            } else {
              img.src = (tag === TASK_CONSTANTS.TASK_TAGS.NO_DATA_ALT) ? purpleDropTaskAlt : purpleDropTask;
            }
            img.style = "width:30px; height: 30px;";
            div.addEventListener("click", (e) => {
              // zoom to pop up location
              const me = this;
              console.log("me", me);
              console.log("setting selected point with data: ", params.data);
              me.$store.dispatch(
                me.STORE_CONSTANTS.TRACKS.ACTIONS.WITH_NAMESPACE
                  .SET_SELECTED_POINT_ID,
                params.data.taskUUID
              );
            });

            div.appendChild(img);
            return div;
          },
          hide: mapHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "duid",
          headerName: "DUID",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            let ptag = document.createElement("p");
            ptag.innerText = params.data.duid || "No Data";
            var img = document.createElement("img");
            img.src = require("../assets/wgmm_ico_copy.svg");
            img.style = "width:20px; height: 20px;";
            img.addEventListener("click", (e) => {
              var copyText = params.data.duid || "No Data";
              navigator.clipboard.writeText(copyText);
            });
            img.addEventListener(
              "mouseenter",
              function (event) {
                img.src = require("../assets/wgmm_ico_copy_active.svg");
              },
              false
            );
            img.addEventListener(
              "mouseleave",
              function (event) {
                img.src = require("../assets/wgmm_ico_copy.svg");
              },
              false
            );
            ptag.appendChild(img);
            div.appendChild(ptag);
            return div;
          },
          hide: duidHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
          sort: "desc",
        },
        {
          field: "spid",
          headerName: "SPID",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            if (params.data.spid) {
              let ptag = document.createElement("p");
              // ptag.innerText = params.data.SPID || "No Data"
              ptag.innerText = params.data.spid || "No Data";
              var img = document.createElement("img");
              img.src = require("../assets/wgmm_ico_copy.svg");
              img.style = "width:20px; height: 20px;";
              img.addEventListener("click", (e) => {
                // var copyText = params.data.SPID || "No Data"
                var copyText = params.data.spid || "No Data";
                navigator.clipboard.writeText(copyText);
                // alert("Copied the text: " + copyText);
              });
              img.addEventListener(
                "mouseenter",
                function () {
                  img.src = require("../assets/wgmm_ico_copy_active.svg");
                },
                false
              );
              img.addEventListener(
                "mouseleave",
                function () {
                  img.src = require("../assets/wgmm_ico_copy.svg");
                },
                false
              );
              ptag.appendChild(img);
              div.appendChild(ptag);
            }
            return div;
          },
          hide: spidHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "taskLabel",
          headerName: "Task Name",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            const element = document.createElement("div");
            const taskName = document.createElement("TR");
            taskName.innerText = params.value;
            element.appendChild(taskName);
            if (params.data.AlternateLocation) {
              const locationIcon = document.createElement("TR");
              const imageElement = document.createElement("img");
              imageElement.src = require("../assets/wgmm_ico_otheraddress.svg");
              imageElement.style.width = "24px";
              imageElement.style.height = "24px";
              imageElement.style.float = "left";

              imageElement.addEventListener("click", (e) => {
                this.$emit("openRecord", {
                  task: params.data,
                  mapInfo: {
                    points: [], //[params.data.geoLocation.lat, params.data.geoLocation.lon], //[params.data.AltInterviewAddress.point.lat, params.data.AltInterviewAddress.point.lon],
                    zoom: 16,
                  },
                });
              });

              locationIcon.appendChild(imageElement);
              element.appendChild(locationIcon);
              const locationLabel = document.createElement("TR");
              const labelThing = document.createElement("label");
              labelThing.innerText =
                params.data.AltInterviewLocation || "No Data";
              labelThing.style.float = "left";
              labelThing.classList.add("label");
              labelThing.classList.add("label-primary");
              labelThing.classList.add("phone");
              locationLabel.appendChild(labelThing);
              element.appendChild(locationLabel);
            }
            return element;
          },
          hide: taskHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "taskStatus",
          headerName: "Status",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            var img = document.createElement("img");
            var tStatus = params.data.taskStatus;
            if (tStatus === "SUSPECT") {
              img.src = require("../assets/wgmm_ico_status_suspect.svg");
            } else if (tStatus === "COMPLETED") {
              img.src = require("../assets/wgmm_ico_status_valid.svg");
            } else if (tStatus === "UNDER_REVIEW") {
              img.src = require("../assets/wgmm_ico_status_in_review.svg");
            } else {
              img.src = require("../assets/wgmm_ico_status_valid.svg");
            }
            // everything other than suspect and under_review gets a check mark for some reason, theres only 3 icons total right now
            img.style = "width:20px; height: 20px;";
            div.addEventListener("click", (e) => {
              console.log("taskStatus click params.data: ", params.data);
              this.currentInfo = params.data;
              this.theTaskId = params.data.taskUUID;
							this.statusChange = params.data.taskStatus;
              console.log("this.theTaskId: ", this.theTaskId);
              this.dialog3 = true;
            });
            div.appendChild(img);
            return div;
          },
          hide: statusHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
        {
          field: "properties.TaskUUID",
          headerName: "Notes",
          resizable: true,
          sortable: true,
          filter: true,
          cellRenderer: (params) => {
            let div = document.createElement("div");
            var img = document.createElement("img");
            img.src = require("../assets/bubble.png");
            img.style = "width:20px; height: 20px;";
            div.addEventListener("click", (e) => {
              this.theTaskId = params.data.TaskUUID;
              this.taskUpdateData = params.data.updates;
              this.taskHistoryPopUp = true;
            });
            div.appendChild(img);
            return div;
          },
          hide: notesHide,
          cellStyle: { display: "flex" },
          filterParams: { newRowsAction: "keep" },
        },
      ];
    },
    /**
     * Sets grid data
     * @param {*} gridData 
     */
    setGridDataWithRefresh(gridData) {
      if (this.gridApi && !this.gridApi.destroyCalled) {
        this.rowData = gridData;
        this.gridApi.setRowData(this.rowData);
        this.getColumnsRefresh();
      }
    },
    /**
     * Sets grid data
     * @param {*} gridData 
     */
    setGridData(gridData) {
      if (this.gridApi && !this.gridApi.destroyCalled) {
        this.rowData = gridData;
        this.gridApi.setRowData(this.rowData);
      }
    },
  },
};
</script>

<style scoped>
@import "../../node_modules/ag-grid-community/styles/ag-grid.css";
@import "../../node_modules/ag-grid-community/styles/ag-theme-alpine.css";

.popover-content {
  position: absolute;
  z-index: 10000;
  width: 400px;
  top: 15px;
  right: 15px;
  background-color: #f5f5f5;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 14px;
  padding-right: 14px;
  text-align: start;
  border: 1px solid rgb(21, 72, 124);
  font-size: 12px;
  box-shadow: 3px 3px 5px 6px rgb(0, 0, 0, 0.2);
}

.comments-container {
  max-height: 260px;
  max-width: 360px;
}

.notes-container {
  overflow: auto;
}

.list-group-item-text {
  margin-bottom: 0;
  line-height: 1;
}

#cancelButton {
  background-color: #f0ad4e;
  color: white;
}

#submitButton {
  background-color: #265a88;
  color: white;
}

.theme--light.v-divider {
  border-color: black;
}
</style>
